import React from 'react';
import { CircularProgress, Stack } from '@mui/material';

export const ChargesListingLoading = () => {
  return (
    <Stack alignItems="center" justifyContent="center" width="100%" height="20rem">
      <CircularProgress />
    </Stack>
  );
};
